import Link from 'next/link';
import { FunctionComponent } from 'react';
import { useTranslation } from 'next-i18next';
import { ArrowRightIcon } from '@heroicons/react/24/solid';

interface Props {
  link: string;
}

const NextButton: FunctionComponent<Props> = ({ link }: Props) => {
  const { t } = useTranslation('common');
  return (
    <Link href="/e/[path]/[id]" as={link} passHref>
      <a className="flex items-center space-x-4 font-light">
        <span>{t('codeRunner.next')}</span>
        <ArrowRightIcon className="h-5 w-5 text-zinc-200" />
      </a>
    </Link>
  );
};

export default NextButton;
